export default function ({ loader, DOMAINS }) {
  const { EventBus: { name, aliasImport } } = DOMAINS

  const dependencies = () => loader.import(aliasImport)

  const loadEventBus = () => loader.import(aliasImport)

  return { name, dependencies, loadEventBus }
}
